import { useState, useEffect, useCallback } from "react";
import axios from "axios";

export default function useUshers(eventId) {
  const [ushers, setUshers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUshers = useCallback(async () => {
    if (!eventId) return;

    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`/checkin/event/${eventId}/ushers`);
      const fetched = response.data?.data?.ushers || [];

      const mapped = fetched.map((checkIn) => {
        const usher = checkIn.usherId || checkIn;

        const displayName =
          usher.fullName ||
          `${usher.firstName || ""} ${usher.lastName || ""}`.trim() ||
          usher.name ||
          "Unnamed Usher";

        return {
          ...usher,
          displayName,
          assignedDate: checkIn.assignedDate,
          status: checkIn.status || "accepted",
          approvalStatus: checkIn.approvalStatus || "pending",
          checkedInGuests: checkIn.checkedInGuests || [],
          usherId: usher._id,
        };
      });

      setUshers(mapped);
    } catch (err) {
      setError("Failed to fetch ushers");
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    fetchUshers();
  }, [fetchUshers]);

  return {
    ushers,
    loading,
    error,
    refetch: fetchUshers,
    setUshers,
  };
}
